import CatalogIconImageLight from "./../../icons/default/catalogLight.png";

import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const CatalogLightIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return <img style={style} className={className} src={CatalogIconImageLight} />;
};
